import { Stack, SxProps } from '@mui/material';

import Correct from './Correct';
import Incorrect from './Incorrect';

export interface EliceAnswerFeedbackProps {
  isCorrect?: boolean;
  sx?: SxProps;
  size?: number;
  correctComponent?: React.ReactNode;
  incorrectComponent?: React.ReactNode;
}

const AnswerFeedback = ({
  isCorrect,
  sx,
  size,
  correctComponent,
  incorrectComponent,
}: EliceAnswerFeedbackProps) => {
  return (
    <Stack
      position="absolute"
      zIndex={99999}
      height="100%"
      width="100%"
      top={0}
      left={0}
      alignItems="center"
      justifyContent="center"
      sx={{ ...sx }}
    >
      {isCorrect ? (
        correctComponent ?? <Correct size={size} />
      ) : (
        incorrectComponent ?? <Incorrect size={size} />
      )}
    </Stack>
  );
};

export default AnswerFeedback;